import axios from 'axios';
import { useRouter } from 'next/router';
import qs from 'qs';
import { useCallback } from 'react';
import { Image } from '@components/common/Image';
import { UiKitButton } from '@components/common/ui-kit-button';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Container } from '@features/Unsubscribe/components/Container';
import { GiftCard } from '@features/Unsubscribe/components/GiftCard';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import { useHandleNext } from '@features/Unsubscribe/utils/go-to-next';
import { WIZARD_STEPS } from '../../сonstants';
import { useGetAppName } from 'src/utils/hooks';
import styles from './GiftPremium.module.scss';
export const GiftPremium = (props: TpWizardSteps) => {
  const {
    defaultEventOptions,
    trackUnsubscribeEvent,
    trackUnsubscribeRequestError,
    trackUnsubscribeRequestSuccess
  } = useUnsubscribeAnalytics();
  const {
    wizard,
    featureFlags
  } = props;
  const {
    query
  } = useRouter();
  const app = useGetAppName();
  const cancelNextStep = featureFlags?.upgrade ? WIZARD_STEPS.SPECIAL_DISCOUNT : WIZARD_STEPS.SAD;
  const handleNext = useHandleNext({
    query: query,
    wizard: wizard,
    url: 'freeze_subscription',
    eventName: 'cancel_gift_premium_chosen',
    options: {
      variant: '1-get 3-month offer'
    },
    successStep: WIZARD_STEPS.PREMIUM_ACTIVATED,
    requestAnalytics: {
      successEventName: 'cancel_subscription_freeze_succeeded',
      errorEventName: 'cancel_subscription_freeze_failed',
      options: {
        endpoint: 'freeze_subscription',
        requestName: 'freeze_subscription'
      }
    }
  });
  const handleCancel = useCallback(async () => {
    const formData = {
      app: app,
      email: defaultEventOptions.email,
      user_id: defaultEventOptions.userId
    };
    const requestOptions = {
      endpoint: 'cancel_subscription',
      requestName: 'cancel_subscription',
      source: 'gift_premium_cancel_anyway'
    };
    try {
      if (!featureFlags?.upgrade) {
        const response = await axios({
          method: 'post',
          url: `${process.env.NEXT_PUBLIC_API_MICROSERVICE_ENDPOINT}cancel_subscription`,
          data: qs.stringify(formData)
        });
        trackUnsubscribeRequestSuccess('cancel_subscription_cancel_succeeded', requestOptions, response.status);
      }
      trackUnsubscribeEvent('cancel_gift_premium_chosen', {
        variant: '2-cancel'
      });
      wizard.goToStep(cancelNextStep);
    } catch (error) {
      trackUnsubscribeRequestError('cancel_subscription_cancel_failed', error, requestOptions);
      wizard.goToStep(WIZARD_STEPS.ERROR);
      console.log('error', error);
    }
  }, [cancelNextStep, defaultEventOptions.email, defaultEventOptions.userId, featureFlags?.upgrade, trackUnsubscribeEvent, trackUnsubscribeRequestError, trackUnsubscribeRequestSuccess, wizard, app]);
  return <Container className={styles.container} eventOnMounted="cancel_gift_premium_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="GiftPremium" data-sentry-source-file="index.tsx">
      <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">
        We gift you our <br />
        Premium for <em className={styles.em}>free!</em>
      </Title>
      <p className={styles.subtitle}>
        Use all the <b>Premium</b> <br />
        features without payment
      </p>
      <Image src="special-3-month.webp" alt="gift-premium" width={327} height={210} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      <GiftCard title="3 months for free" subtitle="special for you" image="present-bow.webp" data-sentry-element="GiftCard" data-sentry-source-file="index.tsx" />

      <ButtonGroup className={styles.buttonGroup} data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
        <UiKitButton color="pure" onClick={handleCancel} className={styles.button} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Cancel anyway
        </UiKitButton>
        <UiKitButton fullWidth onClick={handleNext} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Get my free 3-month offer
        </UiKitButton>
      </ButtonGroup>
    </Container>;
};